import React from "react";
import Footer from "../components/Layout/Footer";
import Header from "./../components/Layout/Header";
import { Box,Typography } from "@mui/material";
import { useMediaQuery } from "@mui/material";




const OurStory = () => {
  const isMobile = useMediaQuery("(max-width:600px)")
  
  return (
    <>
      <Header />
      <Box
      sx={{
        // Use your template image as the background
        backgroundColor:"#f9f8f3",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        // "contain" keeps the entire image visible;
        // "cover" fills the container but may crop the image
        backgroundSize: "contain",
        // For demonstration, set a fixed height or minHeight
        minHeight: "100vh",
        // Or a smaller height if your template is smaller
        // height: "600px",
        position: "relative",
      }}
    >
      <div style={styles.container}>
    
      <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    mt: 5,
    mb: 5,
    width: "100%",
  }}
>
  <Typography
    variant="h3"
    fontWeight="bold"
    sx={{
      fontSize: { xs: "2rem", md: "2.5rem" },
      mb: 1,
      fontFamily: "Teko",
      color: "#5D0A0B",
    }}
  >
    Our Story
  </Typography>
  <Box
    sx={{
      width: { xs: "50%", sm: "40%", md: "30%" }, 
      maxWidth: "200px", 
      height: "3px", 
      backgroundColor: "#5D0A0B",
      mx: "auto",
    }}
  />
</Box>

         <br></br><br></br>

        {/* ✅ First Row */}
        <div style={styles.firstRow}>
  <p style={styles.text}>
  <Typography
  variant="body1"
  sx={{
    textAlign: { xs: "left", md: "justify" }, // Left-align for mobile, justify for desktop
    color: "black",
    fontSize: "18px",
    fontFamily: "Roboto",
    display: "inline-block",
    wordSpacing: "normal",
    hyphens: "auto",
    textJustify: "inter-word", // Improves spacing
  }}
>
      It all began in the heart of Canada, where two souls met for their first date, which was a bit formal. But later when they met again, they both knew they wanted to do something desi. Coincidently they were both “Chai Lovers” so their second date was at a small, cozy café where they shared a pot of masala chai. The warmth of the spiced tea and the comfort of each other's company sparked a connection that grew stronger with every chai date for next 1 month. (WOOT WOOT- They are now engaged😉)
    </Typography>
  </p>
  
  <img
    src="/image/diary1.jpg"
    alt="Story 1"
    style={styles.image}
   
  /> 
</div>


        {/* Dotted Line 1 */}
        <img 
  src="/image/curve1.png" 
  alt="curve 1" 
  style={{ 
    width: "180px", 
    height: "auto", 
    margin: "-10px auto", 
    display: "block",
    transform: "scale(0.7, 0.6)", // Shrinks width & height
    filter: "contrast(200%) brightness(80%)", // Increases boldness effect
  }} 
/>


        {/* ✅ Second Row */}
        <div style={styles.secondRow}>
          <img src="/image/diary2.jpg" alt="Story 2" style={styles.image} />
          <p style={styles.text}>
          <Typography
  variant="body1"
  sx={{
    textAlign: { xs: "left", md: "justify" }, // Left-align for mobile, justify for desktop
    color: "black",
    fontSize: "18px",
    fontFamily: "Roboto",
    display: "inline-block",
    wordSpacing: "normal",
    hyphens: "auto",
    textJustify: "inter-word", // Improves spacing
  }}
>            
              As their love blossomed, so did their shared dream: to bring the authentic taste of South Asian chai to Canada, creating a space where people could connect, share stories, and feel the warmth of South Asian hospitality. But they knew they couldn’t do it alone.  
            </Typography>
          </p>
        </div>

        {/* Dotted Line 2 */}
        <img src="/image/curve2.png" alt="curve 2" style={styles.dottedLineCurve2} />

        {/* ✅ Third Row */}
        <div style={styles.thirdRow}>
          <img src="/image/diary3.jpg" alt="Story 3" style={styles.imageStory3} />
          <p style={styles.text}>
          <Typography
  variant="body1"
  sx={{
    textAlign: { xs: "left", md: "justify" }, // Left-align for mobile, justify for desktop
    color: "black",
    fontSize: "18px",
    fontFamily: "Roboto",
    display: "inline-block",
    wordSpacing: "normal",
    hyphens: "auto",
    textJustify: "inter-word", // Improves spacing
  }}
>           
              This dream led to a greater vision with his 2 other friends, who are as enthusiastic and passionate as him with a knack for turning dreams into reality. Together, the trio embarked on a journey filled with challenges, late-night planning sessions, endless visits by him to various cafés in South Asia, and countless cups of chai. From securing funding to finding the perfect location, they faced countless obstacles, but their shared vision kept them going.    </Typography>
          </p>
        </div>

        {/* Dotted Line 3 (New Connector) */}
        <img src="/image/curve3.png" alt="curve 3" style={styles.dottedLineConnector} />

        {/* ✅ Fourth Row */}
        <div style={styles.fourthRow}>
          <p style={styles.text}>
          <Typography
  variant="body1"
  sx={{
    textAlign: { xs: "left", md: "justify" }, // Left-align for mobile, justify for desktop
    color: "black",
    fontSize: "18px",
    fontFamily: "Roboto",
    display: "inline-block",
    wordSpacing: "normal",
    hyphens: "auto",
    textJustify: "inter-word", // Improves spacing
  }}
>           
              After months of hard work, <span style={{ color: "#5D0A0B" }}>Kadak Cafe</span>&nbsp; was born—a cozy café that blends the rich flavors of South Asian chai with the warmth of Canadian hospitality. The café quickly became a beloved spot for couples, friends, and families to gather, share stories, and create memories.     </Typography>
          </p>
          <img src="/image/KC-Story-DriveThrough.jpeg
          
          " alt="Story 4" style={styles.imageStory4} />
        </div>

        <img 
  src="/image/curve1.png" 
  alt="curve 1" 
  style={{ 
    width: isMobile ? "180px" : "200px", // Slightly increased length in web view
    height: "auto", 
    margin: isMobile ? "-10px auto" : "15px auto 10px 280px", // Adjusted position in web view
    display: "block",
    transform: isMobile ? "scale(0.7, 0.6)" : "rotate(120deg) scale(1.1, 0.6)", // ✅ Rotated more (120°) & scaled slightly in web view
    filter: "contrast(200%) brightness(80%)", 
  }} 
/>



 
 <div style={styles.secondRow}>
          <img src="/image/story4.jpg" alt="Story 2" style={styles.image} />
          <p style={styles.text}>
          <Typography
  variant="body1"
  sx={{
    textAlign: { xs: "left", md: "justify" }, // Left-align for mobile, justify for desktop
    color: "black",
    fontSize: "18px",
    fontFamily: "Roboto",
    display: "inline-block",
    wordSpacing: "normal",
    hyphens: "auto",
    textJustify: "inter-word", // Improves spacing
  }}
>           
              This Team has worked for &nbsp;<span style={{ color: "#5D0A0B" }}>Kadak Cafe</span>&nbsp; as business development managers to interior designers to chef to innovators to investors to carpenters and painters too, you name it and they have done it all… and CREATED this from their SOUL beautifully capturing the essence of love, friendship, and cultural connection. This team made everything possible through thick and thin! A small South Asian experience in this beautiful space of Edmonton!   </Typography>
          </p>
        </div><br></br><br></br>

       
        <Typography
  variant="h6" 
  sx={{ 
    textAlign: "center",
    fontStyle: "italic",
    fontSize: { xs: "1.2rem", md: "1.5rem" }, 
    mt: 2 // optional margin-top
  }}
>
<span style={{ color: "#5D0A0B" }}>Where Love Brews and Stories Unfold.</span>&nbsp; 
</Typography>

      </div>
      </Box>
      <Footer />
    </>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "'Arial', sans-serif",
    color: "#333",
    backgroundColor: "#f9f8f3",
    paddingTop: "50px", // Reduced spacing
  },
  firstRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "10px", // Reduce space
  },
  secondRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "10px",
  },
  thirdRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    position: "relative",
    gap: "10px",
  },
  fourthRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "10px",
  },
  text: {
    width: "45%",
    fontSize: "16px",
    lineHeight: "1.5", // Reduce line height slightly
  },
  image: {
    width: "35%",
    height: "auto",
    borderRadius: "10px",
  },
  imageStory3: {
    width: "45%",
    height: "auto",
    borderRadius: "10px",
  },
  imageStory4: {
    width: "45%",
    height: "70%",
    maxHeight: "250px",
    borderRadius: "10px",
    objectFit: "cover",
  },
  dottedLineCurve1: {
    width: "180px", // Reduced width for larger screens
    height: "auto",
    margin: "-10px auto", // Reduce top space
    display: "block",
   
  
    // Responsive adjustments
    "@media (max-width: 768px)": {
      width: "140px", // Smaller width for tablets
    },
    "@media (max-width: 480px)": {
      width: "120px", // Smaller width for mobile
    }
  },

  dottedLineCurve2: {
    width: "190px",
    height: "auto",
    margin: "-10px auto",
    display: "block",
  },
  dottedLineConnector: {
    width: "200px",
    height: "auto",
    margin: "-5px auto", // Align curve better
    display: "block",
    transform: "rotate(370deg)",
  },
  "@media (max-width: 768px)": {
    dottedLineCurve1: {
      width: "160px",
    },
    dottedLineCurve2: {
      width: "150px",
    },
    imageStory3: {
      width: "90%",
      order: -1,
      marginBottom: "5px", // Reduced space
    },
    imageStory4: {
      width: "90%",
      height: "60%",
      maxHeight: "220px",
      order: -1,
      marginBottom: "5px",
    },
    dottedLineConnector: {
      width: "180px",
      transform: "rotate(370deg)",
      marginBottom: "5px",
    },
    image: {
      width: "90%", // Full width on smaller screens
      maxWidth: "300px", // Limits size for better fit
      display: "block",
      margin: "0 auto", // Centers image
    },
  },
};



export default OurStory;
